import controller from './filter-module-single-controller';

const FilterModuleSingleComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    key: '<',
    filter: '<',
    filterOpts: '<',
    onSelection: '&?',
  },
  template: `
    <div class="filter-module-single">

      <!-- Option Filter Begins -->
      <div class="filter-module-search-container" ng-if="ctrl.minimumOptionsAvailable()">
        <input type="text"
               class="form-control form-control-sm form-control-block"
               ng-model="ctrl.filterPattern"
               ng-model-options="{ debounce: 200 }"
               placeholder="Find..." />
      </div>
      <!-- @Option Filter Ends -->

      <div class="field-group">
          <span ng-if="ctrl.isAllSelectable" class="checkbox-icon option-field">
            <input
              id="filter-select-all-{{ctrl.position}}"
              name="Select All"
              type="radio"
              value="Select All"
              ng-checked="ctrl.selected.all"
              ng-click="ctrl.selectAllOption()"
              />
            <label class="option-label inline-icon" ng-class="{'icon-radio-on': ctrl.selected.all, 'icon-radio-off': !ctrl.selected.all}" for="filter-select-all-{{ctrl.position}}">
              <span>(All)</span>
            </label>
          </span>

        <!-- List Item Begins -->
        <span ng-repeat="option in ctrl.options | filter:{ label: ctrl.filterPattern } | limitTo: 250 track by $index">
          <!-- Single Selection Item Iterator Begins -->
          <span class="checkbox-icon option-field">
            <input
              id="filter-{{ctrl.position}}-{{option.value}}"
              name="{{option.value}}"
              type="radio"
              value="{{option.value}}"
              ng-checked="ctrl.isSelected(option.value)"
              ng-click="ctrl.selectOption(option.value)"
              />
            <label class="option-label inline-icon" ng-class="{'icon-radio-on': ctrl.isSelected(option.value), 'icon-radio-off': !ctrl.isSelected(option.value)}" for="filter-{{ctrl.position}}-{{option.value}}">
              <span ng-class="{'null-option': !option.selected.all && option.value === null}"
                    uib-tooltip="{{option.label}}"
                    tooltip-placement="left"
                    tooltip-append-to-body="true"
                    tooltip-class="wrapping-tooltip-lg"
                    tooltip-popup-delay="250"
                    ng-bind="option.label" />
            </label>
          </span>
          <!-- @Single Selection Item Iterator Ends -->

        </span>
        <!-- @List Item Ends -->
      </div>
    </div>
  `,
};

export { FilterModuleSingleComponent };
